import track from "~/directives/logger-track";

export default defineNuxtPlugin((nuxtApp) => {
  // 注册所有自定义指令
  nuxtApp.vueApp.directive("logger-track", track);
});
